import api from "./client";

const BASE = "/wellness";

export async function createWellness(payload) {
  const { data } = await api.post(
    BASE,
    {
      action: payload.action,
      emotion: payload.emotion,
    },
    {
      headers: {
        "X-Idempotency-Key": payload.idempotencyKey,
      },
    },
  );

  return data;
}

export async function fetchWellnessData(studentIds, startDate, endDate) {
  const { data } = await api.post(`${BASE}/query`, {
    studentIds,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  });

  return data;
}

export async function updateWellnessHelpful(id, helpful) {
  const { data } = await api.patch(`${BASE}/${id}/helpful`, { helpful });

  return data;
}

export async function fetchMyWellness() {
  const { data } = await api.get(`${BASE}/me`);
  return data;
}
